var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7859 4.04956H5.26497C4.94294 4.04956 4.63411 4.1775 4.40641 4.40522C4.1787 4.63294 4.05078 4.94181 4.05078 5.26386V15.7857C4.05078 16.1078 4.1787 16.4166 4.40641 16.6444C4.63411 16.8721 4.94294 17 5.26497 17H15.7859C16.1079 17 16.4167 16.8721 16.6444 16.6444C16.8721 16.4166 17.0001 16.1078 17.0001 15.7857V5.26386C17.0001 4.94181 16.8721 4.63294 16.6444 4.40522C16.4167 4.1775 16.1079 4.04956 15.7859 4.04956Z",
    fill: "#B5B5B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9493 2.83538V1.62109C12.9493 1.1922 12.7793 0.780785 12.4767 0.476946C12.174 0.173108 11.7633 0.00160632 11.3344 0H1.62094C1.19153 0.00159944 0.780167 0.172905 0.476528 0.476572C0.17289 0.780239 0.0015993 1.19164 0 1.62109V11.3355C0.00160618 11.7643 0.173092 12.1751 0.476902 12.4778C0.780713 12.7805 1.19209 12.9505 1.62094 12.9505H2.83512V5.26397C2.83512 4.61987 3.09097 4.00215 3.54637 3.5467C4.00178 3.09125 4.61945 2.83538 5.26349 2.83538H12.9493Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0ea8517cf2878db3b084a9f6c1ef9756.svg";
export { ForwardRef as ReactComponent };